// extracted by mini-css-extract-plugin
module.exports = {"text":"text__2Diwr screenBody__3h2Kk"};